export const PUBLIC = '/public/'
export const STUDENT = '/student/' as const
export const STUDENT_STATUS = `${STUDENT}status` as const
export const STUDENT_ALL = `${STUDENT}all` as const
export const STUDENT_GUARD = `${STUDENT}guard/` as const
export const STUDENT_USERNAME = `${STUDENT}username/` as const
export const STUDENT_ACHIEVEMENT_RECORDS = `${STUDENT}ar_records/` as const
export const STUDENT_PERSONAL_INFO = `${STUDENT}personal_info` as const
export const STUDENT_CONTACT_INFO = `${STUDENT}contact_info` as const
export const STUDENT_ACCOUNT_INFO = `${STUDENT}account-info/` as const
export const STUDENT_ACCOUNT_INFO_WITH_DELETED = `${STUDENT}account-info/with-deleted/` as const
export const STUDENT_FULL_INFO = `${STUDENT}full_info` as const
export const GENERATE_TRANSCRIPT = `${STUDENT}transcript` as const
export const GENERATE_PROOF_OF_STUDY = `${STUDENT}generate/proof-of-study` as const
export const ACHIEVEMENT_RECORDS_STUDENT = `achievement_records/student/` as const
export const STUDENT_PUBLIC_TRANSCRIPT = `${PUBLIC}transcript` as const
export const STUDENT_PUBLIC_STUDY_PROOF = `${PUBLIC}proof-of-study` as const
export const STUDENT_PUBLIC_ID_CARD = `${PUBLIC}student-id-card` as const
export const STUDENT_STUDY_PROOF_GENERATE = `${STUDENT}proof-of-study` as const
export const STUDENT_IMPORT_CU_ID = `${STUDENT}import-cu-id` as const
export const STUDENT_CARD_PRINT = `${STUDENT}card/` as const
export const STUDENT_CARD_ALL = `${STUDENT_CARD_PRINT}all` as const
